var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"modal-header bg-light"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(this.title))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close","aria-hidden":"true"},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("×")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b483cca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ModalTitle.vue
// module id = null
// module chunks = 